import { AppQuizSession_session_questions } from 'globalTypes'

import MultipleChoice from 'Root/Pages/Content/Sessions/Session/Component/Answer/Type/MultipleChoice'
import isNil from 'lodash/isNil'

import Essay from './Type/Essay'
import Matching from './Type/Matching'
import MissingWord from './Type/MissingWord'
import Numerical from './Type/Numerical'
import SingleChoice from './Type/SingleChoice'
import TrueFalse from './Type/TrueFalse'

export interface Props {
  question: AppQuizSession_session_questions
  answer?: any
}

const Answer = ({ question, answer }: Props) => {
  if (isNil(answer)) {
    return <em>Nessuna risposta</em>
  }

  switch (question.__typename) {
    case 'QuizContentQuestionEssay':
      return <Essay answer={answer} question={question} />
    case 'QuizContentQuestionMatching':
      return <Matching answer={answer} question={question} />
    case 'QuizContentQuestionMissingWord':
      return <MissingWord answer={answer} question={question} />
    case 'QuizContentQuestionMultipleChoice':
      return <MultipleChoice answer={answer} question={question} />
    case 'QuizContentQuestionNumerical':
      return <Numerical answer={answer} question={question} />
    case 'QuizContentQuestionSingleChoice':
      return <SingleChoice answer={answer} question={question} />
    case 'QuizContentQuestionTrueFalse':
      return <TrueFalse answer={answer} question={question} />
  }

  return null
}

export default Answer
